import { pathToRegexp } from 'path-to-regexp';

import { removeSpecialCharsAndAccents } from '../utils/url';

export const URL_REGEX = '(http[s]?://)?([^/s]+/)(.*)';
export const BASE_PATH = '/companies';
export const ALTERNATE_PATH = '/company';

export const ROUTES = {
  companies: BASE_PATH,
  followedCompanies: `${BASE_PATH}/my_companies_follow`,
  managedCompanies: `${BASE_PATH}/my_companies_edit`,
  mostVisitedCompanies: `${BASE_PATH}/most_visited`,
  recentlyClaimedCompanies: `${BASE_PATH}/subscriptions`,
  industries: `${BASE_PATH}/industries`,
  industry: `${BASE_PATH}/industries/:industry`,
} as const;

type RouteIndex = keyof typeof ROUTES;

type ChangeURLToMobileProps = {
  mobileProtocol: string;
  url: string;
  slug: string;
  android: boolean;
};

export const changeURLtoMobile = ({
  mobileProtocol,
  url,
  slug,
  android,
}: ChangeURLToMobileProps) => {
  const re = new RegExp(URL_REGEX);
  const url_parts = re.exec(url);
  const protocol = mobileProtocol || url_parts?.[2];

  const queryString = android
    ? '?open_app=deeplink_entity_pages_from_companies'
    : '';

  //TODO: Quick fix to avoid issues with Android and entity pages
  if (android) {
    return `${protocol}/entity/${slug}${queryString}`;
  }

  return `${protocol}entity/${slug}${queryString}`;
};

export const ROUTES_REGEX = Object.keys(ROUTES).reduce(
  (acc: Record<string, RegExp>, key) => {
    acc[key] = pathToRegexp(ROUTES[key as RouteIndex]);
    return acc;
  },
  {}
);

export const getIndustryRoute = ({
  name = '',
  id,
}: {
  name: string;
  id: string;
}) =>
  `${ROUTES.industries}/${id}-${removeSpecialCharsAndAccents(
    name
  ).toLowerCase()}`;

export const getCompanyIndustryRoute = (id: string) =>
  `${ROUTES.industries}/${id}`;

export const EXTERNAL_LINKS = {
  brandmanager: ({ slug }: { slug?: string } = {}) =>
    slug ? `/brandmanager/${slug}` : '/brandmanager',
  teampermissions: ({ companyId }: { companyId?: string } = {}) =>
    companyId ? `/teampermissions/company/${companyId}` : '/teampermissions',
  projobs: '/projobs/settings/jobwish/employer',
  preferences: {
    web: '/jobseeker-criteria/employer?backTo=companies',
    mobileNative: 'jobseeker-criteria/employer',
  },
  search: '/search/companies',
  newCompany: '/pages/new/company',
};

export const getIndustrySearchPageRoute = ({ id }: { id?: string }) => {
  const unscrambledId = id?.split('.')[0];

  return `${EXTERNAL_LINKS.search}?filter.industry[]=${unscrambledId}`;
};

export const COMPANIES_TO_ENTITY_PAGES_SUBPAGE_MATCHING = {
  updates: 'news',
  employees: 'employees',
  jobs: 'jobs',
};
